// import node module libraries
import { Fragment, useEffect, useState } from 'react';
import { Breadcrumb, Card, Col, Row, Tab } from 'react-bootstrap';

// import custom components
import GridListViewButton from 'components/elements/miscellaneous/GridListViewButton';

// import sub components
import OldPersonnelsGridCard from './OldPersonnelsGridCard';
import OldPersonnelsListItems from './OldPersonnelsListItems';
import PersonnelService from '../../services/PersonnelService';

const OldPersonnels = () => {
	const [personnels, setPersonnels] = useState([]);
	const [show, setShow] = useState(false);

	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	useEffect(() => {
		PersonnelService.getAllNonActivePersonnels().then((response) => {
			setPersonnels(response);
		});
	}, []);

	return (
		<Fragment>
			<Tab.Container defaultActiveKey="list">
				<Row>
					<Col lg={12} md={12} sm={12}>
						<div className="border-bottom pb-4 mb-4 d-flex align-items-center justify-content-between">
							<div className="mb-3 mb-md-0">
								<h1 className="mb-1 h2 fw-bold">
									Anciens Personnels{' '}
									<span className="fs-5 text-muted">
										{' '}
										({personnels.length})
									</span>
								</h1>
								<Breadcrumb>
									<Breadcrumb.Item href="/">
										Accueil
									</Breadcrumb.Item>
									<Breadcrumb.Item active>Anciens Personnels</Breadcrumb.Item>
								</Breadcrumb>
							</div>
							<div className="d-flex align-items-center justify-content-between">
								<GridListViewButton keyGrid="grid" keyList="list" />
							</div>
						</div>
					</Col>
				</Row>

				<Tab.Content>
					<Tab.Pane eventKey="grid" className="pb-4">
						{/* personnels in list view */}
						<OldPersonnelsGridCard />
						{/* end of personnels in list view */}
					</Tab.Pane>
					<Tab.Pane eventKey="list" className="pb-4">
						<Card className="mb-5 ">
							<Card.Body className="p-0">
								{/* personnels in list view */}
								<OldPersonnelsListItems />
								{/* end of personnels in list view */}
							</Card.Body>
						</Card>
					</Tab.Pane>
				</Tab.Content>
			</Tab.Container>
		</Fragment>
	);
};
export default OldPersonnels;
